// The reset link carries the one-time code in the query. Read it once, then
// drop it from the address bar before any Identity Toolkit request so the
// code is not the document URL those requests would send as a referrer.

export interface AuthActionQuery {
  mode: string;
  oobCode: string;
}

const ACTION_PATH = "/auth/action";

let captured: AuthActionQuery | null = null;

export function isAuthActionPath(
  pathname: string = window.location.pathname,
): boolean {
  return normalizePath(pathname) === ACTION_PATH;
}

function normalizePath(pathname: string): string {
  if (pathname.length > 1 && pathname.endsWith("/"))
    return pathname.replace(/\/+$/, "");
  return pathname;
}

export function readAuthAction(): AuthActionQuery {
  if (captured) return captured;
  setNoReferrer();
  const params = new URLSearchParams(window.location.search);
  captured = {
    mode: params.get("mode") ?? "",
    oobCode: params.get("oobCode") ?? "",
  };
  stripQuery();
  return captured;
}

function setNoReferrer(): void {
  const found = document.querySelector('meta[name="referrer"]');
  const meta = found ?? document.createElement("meta");
  meta.setAttribute("name", "referrer");
  meta.setAttribute("content", "no-referrer");
  if (!found) document.head.appendChild(meta);
}

function stripQuery(): void {
  if (!window.location.search) return;
  window.history.replaceState(
    window.history.state,
    "",
    window.location.pathname,
  );
}

export function resetAuthActionForTests(): void {
  captured = null;
}
